import dynamic from 'next/dynamic';

export const DateSelector = dynamic(() => import('./date-selector'), { ssr: false });
